import { render, staticRenderFns } from "./CreateRoomDialog.vue?vue&type=template&id=5c2fdcf0&scoped=true"
import script from "./CreateRoomDialog.vue?vue&type=script&lang=js"
export * from "./CreateRoomDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateRoomDialog.vue?vue&type=style&index=0&id=5c2fdcf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2fdcf0",
  null
  
)

export default component.exports